import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M12.7965 5.00098V10.0009C12.7965 11.5473 11.5429 12.8009 9.99648 12.8009C8.45009 12.8009 7.19648 11.5473 7.19648 10.0009V5.00098C7.19648 3.45458 8.45009 2.20098 9.99648 2.20098C11.5429 2.20098 12.7965 3.45458 12.7965 5.00098ZM5.49648 5.00098C5.49648 2.5157 7.5112 0.500977 9.99648 0.500977C12.4818 0.500977 14.4965 2.5157 14.4965 5.00098V10.0009C14.4965 12.4862 12.4818 14.5009 9.99648 14.5009C7.5112 14.5009 5.49648 12.4862 5.49648 10.0009V5.00098ZM2.14648 9.16564V9.99897C2.14648 14.0814 5.26287 17.436 9.24648 17.8136V19.9996H10.9465V17.7921C14.8339 17.3231 17.8465 14.0129 17.8465 9.99897V9.16564H16.1465V9.99897C16.1465 13.3955 13.393 16.149 9.99648 16.149C6.59993 16.149 3.84648 13.3955 3.84648 9.99897V9.16564H2.14648Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const AudioOpenIcon = __component__.exports;
export {
  AudioOpenIcon as default
};
